import { HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'auth';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ENVIRONMENT, Platform } from 'shared';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const auth = inject(AuthService);
  const platform = inject(Platform);
  const environment: any = inject(ENVIRONMENT);
  const router = inject(Router);
  const request$ = (//platform.is('ios') && 
                   platform.is('hybrid') && 
                   req.url.startsWith(environment.serverUrl) &&
                   !req.headers?.has('Authorization')
                  ) 
    ? from(auth.getToken()).pipe(
        switchMap(token => {
          if (token) {    
            return next(req.clone({
              setHeaders: { Authorization: `Bearer ${token}` }
            }));
          }
          return next(req);
        })
      )
    : next(req);

  return request$.pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        auth.setAuthState(null);
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};